<template>
    <div 
        class="e-auto-slider__wrapper"         
        ref="sliderWrapper"
        :class="{ 'is-ready': isReady }"
    >
        <div class="e-auto-slider__track" ref="sliderTrack">
        
            <!-- Duplicate slot content for continuous scroll -->
            <template v-for="i in 2">
                <slot />
            </template>

        </div>

    </div>
</template>

<script>
export default {
    props: {
        speed: {
            type: Number,
            default: 60 // lower = faster
        }
    },
    data() {
        return {
            scrollPosition: 0,
            animationFrame: null,
            isPaused: false,
            isReady: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.isReady = true;
            this.startScrolling();
        });
    },
    methods: {
        startScrolling() {
            const track = this.$refs.sliderTrack;
            if (!track) return;

            const totalWidth = track.scrollWidth / 2;
            const scrollStep = 30 / this.speed;

            const scroll = () => {
                if (this.isPaused) return;

                this.scrollPosition -= scrollStep;
                track.style.transform = `translateX(${this.scrollPosition}px)`;

                if (Math.abs(this.scrollPosition) >= totalWidth) {
                    this.scrollPosition = 0;
                }

                this.animationFrame = requestAnimationFrame(scroll);
            };

            scroll();
        },
    }
};
</script>

<style scoped>
    .e-auto-slider__wrapper {
        overflow: hidden;
        width: 100%;
        position: relative;
    }

    .e-auto-slider__track {
        display: flex;
        flex-wrap: nowrap;
        transform: translateX(0);
        will-change: transform;
    }

    .e-auto-slider__track > * {
        flex: 0 0 auto; /* no gaps between slides */
    }
</style>
